import React,{useEffect} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { ToastContainer,toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

const ParoprofileMain = () => {

  /*----Local storage for display the username in navbar----*/
  
useEffect(()=>{

 document.getElementById("name").innerHTML=localStorage.getItem('username')
 document.getElementById("email").innerHTML=localStorage.getItem('email')

 });
 

    // -----Validation-----//

  function handleSubmit(event){
    event.preventDefault()

    var Current = document.getElementById("Current").value;
    
    var New = document.getElementById("New").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    if(!Current){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
    }
   
    else{
     
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!New){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrB').innerHTML=" ";
    }
   else if (password1.test(document.getElementById('New').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }
   else if (New==Current){document.getElementById('NewErrB').innerHTML=" Don't repeat your Current Password, Try New Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";}

   else{
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
   }
   else if(Confirm != New){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   
   if(Current&&(password1.test(document.getElementById('New').value)===true)&&(Confirm == New)&&(New!=Current))
   {


    //change password//

    const body ={currentPassword: Current, newPassword:New}
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
    axios({
           method: "POST",
           url :`${BASE_URL}/Authenticate/ChangePassword`,
           data: body, 
           headers: {
                "Content-Type": "application/json",
                'Authorization':bearer 
            }     
        }) 
    
  .then((response) =>{
    console.log(response.data);
  
  
   if(response.data.status === "Error"){
       
        toast.error("InCorrect Password ")
      }
  
      else if(response.data.status === "Success"){

        alert("Password Change Successfully!")
  
        // toast.success("Password Change Successfully!", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
          setTimeout(() => {
            
            window.location.href="/#/"
          }, 500);
       
       
  
      }
    })
    .catch(error => {
      console.log(error);
    //  alert("failed !")
    toast.error(' Old Password is Incorrect ')
     
    })
      
  
     
     
   
  }
  } 
  
  //Validation//

  function handlechange(event){
    event.preventDefault()


    var Current = document.getElementById("Current").value;
    
    var New = document.getElementById("New").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    if(!Current){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
      document.getElementById('CurrentErrA').innerHTML=" ";
    }
    
    else{
      
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!New){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
    }
   else if (password1.test(document.getElementById('New').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }
   else if (New==Current){document.getElementById('NewErrB').innerHTML=" Don't repeat your Current Password, Try New Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";}


   else{
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
    document.getElementById('ConfirmErrA').innerHTML=" ";
   }
   else if(Confirm != New){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
    
   
  }



   
  


 /*----Function open form----*/

 function Changeformopen(event){
 event.preventDefault()

 

    document.getElementById("modalRegisterForm").style.display = "block";

  }
  

/*----Function close form----*/

  function changeformclose()

  {

    document.getElementById("CurrentErr").innerHTML=" ";

   
    document.getElementById("NewErr").innerHTML="  ";  

    document.getElementById("NewErrA").innerHTML="  ";  
    document.getElementById('NewErrB').innerHTML=" ";

    document.getElementById("ConfirmErr").innerHTML="  ";  

    document.getElementById("ConfirmErrA").innerHTML="  ";

    



    document.getElementById("paroform").reset();

     document.getElementById("modalRegisterForm").style.display = "none";

   }


   /*----Password Function-----*/

   function Parohide1(){

         

    var x = document.getElementById("Current");

    var eye = document.getElementById("Paroeye1");



    if(x.type === "password"){



      x.type = "text";

      eye.classList.remove("fa-eye-slash")

      eye.classList.add("fa-eye")

     

    }

    else{

      x.type = "password";

      eye.classList.remove("fa-eye")

      eye.classList.add("fa-eye-slash")

    }



   }

   function Parohide2(){

         

    var x = document.getElementById("New");

    var eye = document.getElementById("Paroeye2");



    if(x.type === "password"){



      x.type = "text";

      eye.classList.remove("fa-eye-slash")

      eye.classList.add("fa-eye")

     

    }

    else{

      x.type = "password";

      eye.classList.remove("fa-eye")

      eye.classList.add("fa-eye-slash")

    }



   }


   function Parohide3(){

         

    var x = document.getElementById("Confirm");

    var eye = document.getElementById("Paroeye3");



    if(x.type === "password"){



      x.type = "text";

      eye.classList.remove("fa-eye-slash")

      eye.classList.add("fa-eye")

     

    }

    else{

      x.type = "password";

      eye.classList.remove("fa-eye")

      eye.classList.add("fa-eye-slash")

    }



   }
   
   


   




  return (

    <>
    <div className='Paro-addmain'>
      
        {/*  Toastify */ }

    <ToastContainer id="toast"

position="top-center"

autoClose={1500}

hideProgressBar={false}

newestOnTop={false}

closeOnClick

rtl={false}

pauseOnFocusLoss

draggable

pauseOnHover

/>
    <div className="Paro-addgrid-layout">
    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/Paropakari '><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Welcome to Your Profile</span>
 

     </div>
 </div>
 
 <div>
       <div className="modal-dialog" role="document">
          <div className="modal-content">

            {/* <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
       
                <span aria-hidden="true">&times;</span>
              
            </div> */}


      
            <form >
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
         
                     <span type="text" className="form-control validate"  id="name" readOnly></span>
        
                  </div>

                  <div className="md-form mb-5">
          
                      <span type="email"  className="form-control validate" id="email" readOnly ></span>
         
                  </div>

                  
                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="Paro-profile-button" onClick={Changeformopen} >Change Password</button>
                  </div>

           </form>



          </div>
     </div>
</div>



<div className="Paro-profile-fade" id="modalRegisterForm" tabindex="-1" role="dialog"
  aria-hidden="true">
       <div className="modal-dialog" role="document" id="Parocenterform">
          <div className="modal-content">

            <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">CHANGE PASSWORD</h4>
                <button type="button" className="close" onClick={changeformclose}>
                <span aria-hidden="true">&times;</span>
                </button>
            </div>


      
            <form onSubmit={handleSubmit} id="paroform">
              <div className="modal-body mx-3">

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>

                  <input type="Password" className="form-control validate" onKeyUp={handlechange} placeholder='Current Password' id="Current"/>
                     <span className='Paroeyeicon1'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Parohide1} id="Paroeye1"></i></span>
  
                 </div>
         
                     
                     <span  className='error' id="CurrentErr"></span>
                   
        
                  </div>

                  <div className="md-form mb-5">
                    <div style={{display:"flex"}}>
                    <input type="Password"  className="form-control validate"onKeyUp={handlechange} placeholder='New Password' id="New" />
                      <span className='Paroeyeicon2'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Parohide2} id="Paroeye2"></i></span>

                    </div>
          
                     
                      <span className='error' id="NewErr"></span>
                     <span className='error' id="NewErrA"></span>
                     <span className='error' id="NewErrB"></span>
         
                  </div>

                  <div className="md-form mb-5">
                    <div style={{display:"flex"}}>
                    <input type="Password" className="form-control validate" onKeyUp={handlechange}  placeholder='Confirm Password'  id="Confirm"/>
                      <span className='Paroeyeicon3'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Parohide3} id="Paroeye3"></i></span>

                    </div>
          
                     
                      <span className='error' id="ConfirmErr"></span>
                     <span  className='error' id="ConfirmErrA"></span>
         
                  </div>
                        

                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="Paro-adduser-button" >Submit</button>
                  </div>

             </form>



          </div>
     </div>
</div>

 
 </div>
 </>
   
  )
}

export default ParoprofileMain